import { create } from 'zustand';

/**
 * Whether the clinic's account has gone read-only for non-payment.
 *
 * Not fetched — learned. The API answers 402 to any write once the subscription lapses, so the
 * axios interceptor sets this the first time one comes back and the banner appears everywhere at
 * once. Polling a status endpoint would be a second source of truth that could disagree with the
 * thing actually refusing the writes.
 *
 * Reads keep working throughout, so the app stays usable behind the banner: the clinic can see its
 * calendar and its patients, it just cannot change them until the bill is settled.
 */
interface BillingState {
  /** The message the API sent, or null while everything is fine. */
  lockedReason: string | null;
  setLocked: (reason: string) => void;
  clear: () => void;
}

export const useBillingStore = create<BillingState>((set) => ({
  lockedReason: null,
  // Idempotent on purpose: a screen firing several writes must not flicker the banner.
  setLocked: (reason) => set((s) => (s.lockedReason === reason ? s : { lockedReason: reason })),
  clear: () => set({ lockedReason: null }),
}));
